import { Carousel, Col, Collapse, Image, Row, Skeleton } from 'antd';
import { useEffect, useState } from 'react';
import ImageCarousel from './ImageCarousel';

const DiseaseImages = (props) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch('data/images/diseases_images.json')
      .then((response) => response.json())
      .then((json) =>
        setImages(
          json[props.label.toLowerCase()].reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / 5);

            if (!resultArray[chunkIndex]) {
              resultArray[chunkIndex] = [];
            }

            resultArray[chunkIndex].push(item);

            return resultArray;
          }, [])
        )
      )
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  return (
    <ImageCarousel images={images}></ImageCarousel>
  );
};

export default DiseaseImages;
